import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";

import { AuthenticationService } from 'app/auth/service';
import { TokenOAuth } from 'app/auth/models/token-oauth';

@Pipe({
    name: 'secure'
})
export class SecurePipe implements PipeTransform {

    constructor(private http: HttpClient, private sanitizer: DomSanitizer, private _authenticationService: AuthenticationService) {}

    transform(url): Observable<SafeUrl> {
        const tokenOAuth: TokenOAuth = this._authenticationService.tokenOAuthValue;
        let pathComplete = `${process.env.APIURL}api/app/${url}`;
        return this.http
            .get(pathComplete, {
               responseType: 'blob',
               headers: new HttpHeaders({
                authorization: `Bearer ${tokenOAuth?.access_token}`
               })
            })
            .pipe(map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));
    }

}